module.exports = __webpack_public_path__ + "static/img/leah_1000.6e487fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/team/leah_1000.jpg
// module id = JQX0
// module chunks = 1